import axios from 'axios';
import AuthenticationStore from './AuthenticationStore.js';
import AppCommHandler from './AppCommHandler';

var base64 = require('base-64');
const httpClient = axios.create(
	{
		validateStatus: function (status)
		{
			return status == 200;
		}
	}
);
httpClient.defaults.timeout = 400000000;
const store = null;
let requestInProgressCount = 0;
httpClient.interceptors.request.use((config) => {
	if (!config.__backgroundRequest && !config.__isRetryRequest) {
		requestInProgressCount++;
		if (requestInProgressCount == 1) {
			AppCommHandler.APIStartEvent();
		}
	}
	return config;
});


httpClient.interceptors.response.use(function (response) {
	if (!response.config.__backgroundRequest) {
		requestInProgressCount--;
		if (requestInProgressCount == 0) {
			AppCommHandler.APIEndEvent();
		}
		if (requestInProgressCount < 0) {
			requestInProgressCount = 0;
		}
	}
	if(response.status == 302) {
		// now session is expired show him an alert and redirect to login page
		AppCommHandler.APISessionExpiredEvent();
	}
	return response;
}, function (err) {
	let res = err.response;
	if(typeof res ==='undefined'){
		AppCommHandler.APIEndEvent();
		AppCommHandler.APISessionExpiredEvent();
		//this looks like an ntwork error. Need to be handled nicely.
		return Promise.reject(err);
	}
	if(res.status == 302) {
		// now session is expired show him an alert and redirect to login page
		AppCommHandler.APISessionExpiredEvent();
		return Promise.reject(err);
	}
	if (!res.config.__backgroundRequest) {
		requestInProgressCount--;
		if (requestInProgressCount == 0) {
			AppCommHandler.APIEndEvent();
		}
		if (requestInProgressCount < 0) {
			requestInProgressCount = 0;
		}
	}
	return Promise.reject(err);
});



const createRequest = (serviceURL, input, method, options) => {
	let request = {
		method: method,
		maxRedirects: 0,
		url: window.env.API_URL + serviceURL,
		headers: {
			"Content-Type": "application/json",
			'Accept': 'application/json',
			'Access-Control-Allow-Origin': '*',
			'Access-Control-Allow-Methods': 'POST, PUT, GET, OPTIONS, DELETE',
		}
	};

	if (typeof options !== "undefined" && options != null) {
		if (typeof options.timeout !== "undefined") {
			request.timeout = options.timeout;
		}
	}
	if (typeof options !== "undefined" && options != null) {
		if (typeof options.__isAuth !== "undefined") {
			request.__isAuth = options.__isAuth;
		}
	}
	if (typeof options !== "undefined" && options != null) {
		if (typeof options.__backgroundRequest !== "undefined" && options.__backgroundRequest != null) {
			request.__backgroundRequest = options.__backgroundRequest;
		}
	}
	if (method.toLowerCase() !== "get") {
		if (typeof input === 'object') {
			request.data = JSON.stringify(input);
		} else {
			request.data = input;
		}
	} else {
		request.params = input;
	}
	return request;
};

const performAuthentication = (backGround) => {
	var AuthValidation = new Promise(
		function (resolve, reject) {
			try {
				var authEndPoint = '/session';
				var param={};
				//getData(api, input, options) {
				WebCall(authEndPoint, param, 'GET', { __isAuth: true, __backgroundRequest: backGround }).then(res => {
					if(res.data.status !='undefined' && res.data.status=='failed'){
						AuthenticationStore.cleanup();
						AuthenticationStore.initialized = true;
						reject("FAILED"); // reject
					} else {
						AuthenticationStore.initialized = true;
						resolve("SUCCESS"); // fulfilled
					}
				}).catch(error => {
					AuthenticationStore.cleanup();
					AuthenticationStore.initialized = true;
					reject("FAILED"); // reject
				});
			} catch (e) {
				AuthenticationStore.cleanup();
				AuthenticationStore.initialized = true;
				reject("FAILED"); // reject
			}
		});
	return AuthValidation;
};

const WebCall = (serviceURL, input, method, options) => {
	let request = createRequest(serviceURL, input, method, options);
	var FetchData = new Promise(
		function (resolve, reject) {
			httpClient(request).then(res => {
				resolve(res);
			}).catch(err => {
				reject(err);
			});
		});
	return FetchData;
};


//incase of token error we need to try once again with refresh token
export const AuthAPI = {
	performAuthentication: performAuthentication
}
const WebAPI = {
	getData(api, input, options) {
		return WebCall(api, input, 'GET', options);
	},
	postData(api, input, options) {
		return WebCall(api, input, 'POST', options);
	},
	putData(api, input, options) {
		return WebCall(api, input, 'PUT', options);
	},
	deleteData(api, input, options) {
		return WebCall(api, input, 'DELETE', options);
	},
	isLoading() {
		return requestInProgressCount !== 0;
	}
};
export default WebAPI;

